import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=447a9649&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"
import style0 from "./GallerySection.vue?vue&type=style&index=0&id=447a9649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a9649",
  null
  
)

export default component.exports